import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export const styles = mergeStyleSets({
  selectedContainer: {
    display: 'flex',
    flexFlow: 'row',
  },
  multiPicker: { background: 'red' },
  defaultSelectedItem: {
    borderRadius: 2,
    margin: pxToRem(2),
    padding: 2,
    paddingLeft: 2,
    paddingRight: 2,
    background: theme.palette.neutralTertiary,
    boxSizing: 'content-box',
  },
  tagOption: {
    background: theme.palette.neutralLighterAlt,
    borderRadius: pxToRem(25),
    marginLeft: pxToRem(5),
    marginRight: pxToRem(5),
    paddingLeft: pxToRem(5),
    paddingRight: pxToRem(5),
    lineHeight: pxToRem(20),
    textAlign: 'center',
    fontSize: pxToRem(12),
  },
  iconClear: {
    fontSize: pxToRem(8),
    lineHeight: pxToRem(20),
    color: theme.palette.themePrimary,
  },
});

export default {
  dropdown: {
    selectors: {
      '& > .ms-Dropdown-title': {
        backgroundColor: theme.palette.neutralWhite,
        borderColor: theme.palette.neutralTertiary,
        fontWeight: 400,
      },
    },
  },
};
